import React, { useEffect, useState } from "react";
import {
  Page,
  Text,
  View,
  Document,
  Image as ReactPdfImage,
} from "@react-pdf/renderer";

// Custom.
import { TemplateProps } from "../global";
import { styles } from "./styles";
import { baseStyles } from "../styles";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import {
  getContactName,
  getGroupLogotype,
} from "@vocollege/app/dist/modules/VoHelpers";
import { GeneralObject } from "@vocollege/app/dist/global";
import { convertSvgToImage } from "@vocollege/app/dist/modules/VoHelpers";
import LogoPlaceholder from "../components/LogoPlaceholder/LogoPlaceholder";
import { getTutorCertificateModules } from "services/Utils";

const TutorCertificateTemplate: React.FC<TemplateProps> = (props) => {
  const { item } = props;
  const [logotype, setLogotype] = useState<any>(null);
  const [graphPath, setGraphPath] = useState<string>("");

  // Methods.

  const generateLogotype = async () => {
    let output: GeneralObject[] = [];
    try {
      getGroupLogotype(item.region, "logo2", output);
      if (output.length > 0) {
        let convertedImage = await convertSvgToImage(output[0].url, 260);
        setLogotype(convertedImage);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const generateGraphPath = () => {
    let fileName: string[] = [];
    if (item.steps.indexOf("1") > -1) {
      fileName.push("step1");
    }
    if (item.steps.indexOf("2") > -1) {
      const sortedStep2Modules = item?.step2 ? [...item.step2].sort() : [];
      const availableModules = getTutorCertificateModules(2);
      if (sortedStep2Modules.length === availableModules.length) {
        fileName.push("step2");
      } else {
        sortedStep2Modules.forEach((v: string) => {
          fileName.push(v);
        });
      }
    }
    if (item.steps.indexOf("3") > -1) {
      fileName.push("step3");
    }
    const path =
      fileName.length > 0
        ? `/images/handledarintyg/${fileName.join("_")}.png`
        : "/images/handledarintyg/nosteps.png";
    setGraphPath(path);
  };

  const hasModule = (step: string, module: string) => {
    return (
      item &&
      item?.steps.indexOf(step) > -1 &&
      item[`step${step}`]?.indexOf(module) > -1
    );
  };

  const getPublisherText = () => {
    if (!item.local_id || item.local_id === "0") {
      return I18n.trans(I18n.get.tutorCertificate.template.region, {
        region: item.region.title,
      });
    }
    let local = item.region.groups.find((v: any) => item.local_id === v.id);
    if (item.educator_id && item.educator_id !== "0") {
      let educator = local.groups.find((v: any) => item.educator_id === v.id);
      return educator && educator.title;
    }
    return I18n.trans(I18n.get.tutorCertificate.template.local, {
      local: local.title,
    });
  };

  // Effects.

  useEffect(() => {
    if (item) {
      generateLogotype();
      generateGraphPath();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    // @ts-ignore
    <Document>
      {/*
 // @ts-ignore */}
      <Page size="A4" style={(baseStyles.page, styles.page)} wrap={false}>
        <View style={styles.decor}>
          <View style={styles.header}>
            {logotype && (
              <ReactPdfImage
                src={logotype}
                style={(baseStyles.logo, styles.logo)}
              />
            )}
            {!logotype && <LogoPlaceholder />}

            <View style={styles.titleWrapper}>
              <Text style={styles.title}>
                {I18n.get.tutorCertificate.template.title}
              </Text>
              {item && (
                <Text style={styles.subtitle}>
                  {I18n.get.tutorCertificate.template.handledarutbildning}
                </Text>
              )}
            </View>

            <View style={styles.personWrapper}>
              <Text style={styles.person}>
                {item &&
                  (item.firstname || item.lastname) &&
                  getContactName(item)}
              </Text>
              <Text style={styles.personalNumber}>
                {item && item.personal_number}
              </Text>
            </View>
          </View>
          {/* <View style={baseStyles.section}>
            <Text style={styles.person}>
              {item &&
                (item.firstname || item.lastname) &&
                getContactName(item)}
            </Text>
            <Text style={styles.personalNumber}>
              {item && item.personal_number}
            </Text>
          </View> */}

          {/* <View style={baseStyles.section}>
            <Text style={styles.text}>{getStepDescription("a")}</Text>
            <Text style={styles.text}>{getStepDescription("b")}</Text>
            <Text style={styles.text}>
              {item &&
                item.scope &&
                item.scope !== "" &&
                I18n.trans(I18n.get.tutorCertificate.template.scope, {
                  scope: item.scope,
                })}
            </Text>
          </View> */}

          <View style={styles.growArea}>
            <View style={styles.stepSectionWrapper}>
              {item?.steps.indexOf("1") > -1 && (
                <View style={styles.stepSection}>
                  <Text style={styles.stepTitle}>
                    {I18n.get.tutorCertificate.template.step1Title}
                  </Text>
                  <Text style={styles.stepDescription}>
                    {I18n.get.tutorCertificate.template.step1Description}
                  </Text>
                </View>
              )}

              {/* <View style={styles.stepSection}>
              <Text style={styles.text}>
                {I18n.get.tutorCertificate.template.step2Title}
              </Text>
              </View> */}

              {hasModule("2", "step2-mod01") && (
                <View style={styles.stepSection}>
                  <Text style={styles.stepTitle}>
                    {
                      I18n.get.tutorCertificate.template
                        .step2PabyggnadsmodulTitle
                    }
                  </Text>
                  <Text style={styles.stepDescription}>
                    {
                      I18n.get.tutorCertificate.template
                        .step2PabyggnadsmodulDescription
                    }
                  </Text>
                </View>
              )}

              {hasModule("2", "step2-mod02") && (
                <View style={styles.stepSection}>
                  <Text style={styles.stepTitle}>
                    {I18n.get.tutorCertificate.template.step2LarlingsmodulTitle}
                  </Text>
                  <Text style={styles.stepDescription}>
                    {
                      I18n.get.tutorCertificate.template
                        .step2LarlingsmodulDescription
                    }
                  </Text>
                </View>
              )}

              {hasModule("2", "step2-mod03") && (
                <View style={styles.stepSection}>
                  <Text style={styles.stepTitle}>
                    {
                      I18n.get.tutorCertificate.template
                        .step2SprakochinkluderingsmodulTitle
                    }
                  </Text>
                  <Text style={styles.stepDescription}>
                    {
                      I18n.get.tutorCertificate.template
                        .step2SprakochinkluderingsmodulDescription
                    }
                  </Text>
                </View>
              )}

              {hasModule("2", "step2-mod04") && (
                <View style={styles.stepSection}>
                  <Text style={styles.stepTitle}>
                    {
                      I18n.get.tutorCertificate.template
                        .step2ValideringsmodulTitle
                    }
                  </Text>
                  <Text style={styles.stepDescription}>
                    {
                      I18n.get.tutorCertificate.template
                        .step2ValideringsmodulDescription
                    }
                  </Text>
                </View>
              )}

              {item?.steps.length === 1 && item.steps.indexOf("3") > -1 && (
                <View style={styles.stepSection}>
                  <Text style={styles.stepTitle}>
                    {I18n.get.tutorCertificate.template.step3Title}
                  </Text>
                  <Text style={styles.stepDescription}>
                    {I18n.get.tutorCertificate.template.step3Description}
                  </Text>
                </View>
              )}

              {item && item.scope && item.scope !== "" && (
                <View style={styles.scopeSection}>
                  <Text style={styles.text}>
                    {I18n.trans(I18n.get.tutorCertificate.template.scope, {
                      scope: item.scope,
                    })}
                  </Text>
                </View>
              )}

              {graphPath !== "" && (
                <View style={styles.graphWrapper}>
                  <ReactPdfImage src={graphPath} style={styles.graph} />
                </View>
              )}
            </View>
          </View>

          <View style={styles.publisherSection}>
            {item && item.region && (
              <Text style={styles.publisher}>{getPublisherText()}</Text>
            )}
            {item && <Text style={styles.date}>{item.date}</Text>}
          </View>

          {/* <View style={baseStyles.grow} debug></View> */}

          <View style={[baseStyles.section, styles.footer]}>
            {item &&
              ((item.responsible && item.responsible !== "") ||
                (item.responsible2 && item.responsible2 !== "")) && (
                <View style={styles.signatures}>
                  {item && item.responsible && item.responsible !== "" && (
                    <View style={styles.signature}>
                      <Text style={styles.signaturePerson}>
                        {item.responsible}
                        {/* {getContactName(item.responsible)} */}
                      </Text>
                      <Text style={styles.signatureTitle}>
                        {I18n.get.tutorCertificate.template.responsible}
                      </Text>
                    </View>
                  )}
                  {item && item.responsible2 && item.responsible2 !== "" && (
                    <View style={styles.signature}>
                      <Text style={styles.signaturePerson}>
                        {item.responsible2}
                        {/* {getContactName(item.responsible2)} */}
                      </Text>
                      <Text style={styles.signatureTitle}>
                        {I18n.get.tutorCertificate.template.responsible}
                      </Text>
                    </View>
                  )}
                </View>
              )}
          </View>
          {item && item.uid && item.uid.code && (
            <Text style={[baseStyles.uid, styles.uid]}>{item.uid.code}</Text>
          )}
        </View>
      </Page>
    </Document>
  );
};
export default TutorCertificateTemplate;
